import { JSX, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthContext } from '../contexts/auth.context';
import { useNavigation } from '../hooks/navigation.hook';
import { PageLoading } from './page-loading';

interface AuthGuardProps {
  isProtected: boolean;
}

export function AuthGuard({ isProtected }: AuthGuardProps): JSX.Element {
  const { navigate } = useNavigation();
  const { isUserLoading, isLoggedIn } = useAuthContext();

  const shouldNavigate = !isUserLoading && isLoggedIn !== isProtected;

  useEffect(() => {
    if (shouldNavigate) navigate(isLoggedIn ? '/habits' : '/', { replace: true });
  }, [isUserLoading, isLoggedIn, isProtected]);

  return shouldNavigate ? <PageLoading /> : <Outlet />;
}
